export const EffectType = Object.freeze({
  Increase: 'increase',
  Decrease: 'decrease',
});

export enum RiskType {
  COST = 'cost',
  TIME = 'time',
}
